export enum Role {
	MUNICIPALITY_ADMIN = 'ROLE_MUNICIPALITY_ADMIN',
	SUPPLIER = 'ROLE_SUPPLIER',
	CITIZEN = 'ROLE_CITIZEN',
}
